// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` /* Main Container */
 .terms-container {
    padding: 20px;
    max-width: 800px;
    margin: 0 auto;
  }
  
  /* Return Link */
  .terms-link {
    color: #007bff;
    text-decoration: none;
  }
  
  .terms-link:hover {
    text-decoration: underline;
  }
  
  /* Section Styling */
  .terms-section {
    margin-bottom: 40px;
    padding-bottom: 20px;
    border-bottom: 1px solid #ddd;
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/TermsAndPrivacy.css"],"names":[],"mappings":"CAAC,mBAAmB;CACnB;IACG,aAAa;IACb,gBAAgB;IAChB,cAAc;EAChB;;EAEA,gBAAgB;EAChB;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,oBAAoB;EACpB;IACE,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;EAC/B","sourcesContent":[" /* Main Container */\n .terms-container {\n    padding: 20px;\n    max-width: 800px;\n    margin: 0 auto;\n  }\n  \n  /* Return Link */\n  .terms-link {\n    color: #007bff;\n    text-decoration: none;\n  }\n  \n  .terms-link:hover {\n    text-decoration: underline;\n  }\n  \n  /* Section Styling */\n  .terms-section {\n    margin-bottom: 40px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid #ddd;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
